import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { Row, Container } from 'reactstrap';
import { ProgramCard } from '../../cards';
import COLORS from '../../../../../common/colors';
import RightArrow from '../../icons/rightArrowSmall';
import { program } from '../../../../../store';

const ProgramPanel = (props) => {
	const { title, programs, viewAll, session, width, AB, newTab, defaultMatchingPercentage, tenantConfig, theme } = props;
	return (
		<Container className="panel-padding">
			<MediaQuery minWidth={576} device={{ width }}>
				<Row>
					<a href={viewAll}
						onClick={() => {
							const eventInfo = {
								prevPage: title.split(' ')[0],
							};

							if (window.eventDispatcher) {
								window.eventDispatcher.dispatchEventSync('program-panel-viewAll', eventInfo, { amplitude: true });
							}

							return true;
						}
						}
						className="no-hover-a" style={{ cursor: 'pointer' }}>
						<h2 className="mr-auto" style={{ marginBottom: '2rem' }}>{title}</h2>
					</a>
					<a
						href={viewAll}
						onClick={() => {
							const eventInfo = {
								prevPage: title.split(' ')[0],
							};

							if (window.eventDispatcher) {
								window.eventDispatcher.dispatchEventSync('program-panel-viewAll', eventInfo, { amplitude: true });
							}

							return true;
						}


						}
						className="ml-auto no-hover-a"
						style={{
							fontSize: '0.875rem',
							color: COLORS.giveDarkerGrey,
						}}
					>
						<span style={{
							paddingRight: '6px',
						}}
						>View All
				</span> <RightArrow />
					</a>
				</Row>
			</MediaQuery>
			<MediaQuery maxWidth={576} device={{ width }}>
				<Row style={{ paddingLeft: '15px' }}>
					<a
						onClick={() => {
							const eventInfo = {
								prevPage: title.split(' ')[0],
							};

							if (window.eventDispatcher) {
								window.eventDispatcher.dispatchEventSync('program-panel-viewAll', eventInfo, { amplitude: true });
							}

							return true;
						}


						}
						href={viewAll}
						className="no-hover-a"
						style={{ cursor: 'pointer' }}
					>
						<h2 className="mr-auto" style={{ marginBottom: '2rem' }}>{title}</h2>
					</a>
				</Row>
			</MediaQuery>

			<Row>
				{programs && programs.map((program, index) => (

					<ProgramCard
						type="homePage"
						panelTitle={title}
						position={index}
						matching={program.matching}
						program={program}
						session={session}
						key={`program-${index}`}
						AB={AB}
						theme={theme}
						newTab={newTab}
						lazyLoadImage={true}
						defaultMatchingPercentage={defaultMatchingPercentage}
						tenantConfig={tenantConfig}
					/>
				))}
			</Row>
			<MediaQuery maxWidth={576} device={{ width }}>
				<Row style={{ paddingRight: '15px' }}>
					<a
						onClick={() => {
							const eventInfo = {
								prevPage: title.split(' ')[0],
							};

							if (window.eventDispatcher) {
								window.eventDispatcher.dispatchEventSync('program-panel-viewAll', eventInfo, { amplitude: true });
							}

							return true;
						}


						}
						href={viewAll}
						className="ml-auto no-hover-a"
						style={{
							fontSize: '0.875rem',
							color: COLORS.giveDarkerGrey,
						}}
					>
						<span style={{
							paddingRight: '6px',
						}}
						>View All
					</span> <RightArrow />
					</a>
				</Row>
			</MediaQuery>
		</Container>);
}

ProgramPanel.propTypes = {
	programs: PropTypes.arrayOf(PropTypes.shape({
		title: PropTypes.string.isRequired,
		programLink: PropTypes.string.isRequired,
		cause: PropTypes.string.isRequired,
		location: PropTypes.string.isRequired,
		ngo: PropTypes.string.isRequired,
		image: PropTypes.string.isRequired,
		price: PropTypes.number.isRequired,
	})).isRequired,
	title: PropTypes.string.isRequired,
	viewAll: PropTypes.string.isRequired,
};
export default ProgramPanel;
